import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';
import { AgreementStatus } from "@app/enumerations/agreement-status";

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {

  constructor(private router: Router, private activeRoute: ActivatedRoute) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {  

    let authorized: boolean = false;   
       
    switch (route.routeConfig.component.name) {
      case "LandingComponent": {              
        if (!LocalStorageUtilities.getPersonPortalState().loggedIn && LocalStorageUtilities.getPersonPortalState().acceptedAgreement !== AgreementStatus.ACCEPTED) {
          authorized = true;
        }       
        break;
      };
      case "MainComponent": {                
        authorized = LocalStorageUtilities.getPersonPortalState().loggedIn && LocalStorageUtilities.getPersonPortalState().acceptedAgreement === AgreementStatus.ACCEPTED;       
        if (!authorized) {
          this.router.navigate(['/landing']);
        }
        break;
      };
      case "SiteAgreementComponent": {
        // If the user's credentials are valid, and he has accepted the Use Agreement then allow him to navigate to the Main screen;
        // otherwise, navigate the user to the "Site Agreement" screen.
        if (LocalStorageUtilities.getPersonPortalState().loggedIn && LocalStorageUtilities.getPersonPortalState().acceptedAgreement === AgreementStatus.NONE) {
           authorized = true;
        } else if (LocalStorageUtilities.getPersonPortalState().loggedIn && LocalStorageUtilities.getPersonPortalState().acceptedAgreement === AgreementStatus.DECLINED) {
          authorized = true;
        }                
        break;
      };
    }

    return authorized;

  }
}
